import { Deserializable } from '../deserializable';
import { DocumentRequest } from './document-request';

export class LoanAgreementRequest extends DocumentRequest implements Deserializable {
  amount: number;
  dateOfTransaction: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
